function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect } from "react";
import classNames from "classnames";
import "./personalDashboard.css";
import statsDown from "../img/stats-down.jpg";
import statsUp from "../img/stats-up.jpg";
import { Chart } from "react-google-charts";
import { Spinner } from "react-bootstrap";
import { convertToHoursAndMinutes } from "../utils";
import { appStatusColors } from "../theme";
import moment from "moment-timezone";
import { useQuery } from "@apollo/client";
import { USER_TOP_APPS_USED_QUERY, PERSONAL_DASHBOARD_METRICS_QUERY } from "./query";
import { FilterContext, UserContext } from "../index";
var apps = [{
  name: "drive.google.com",
  status: "productive",
  icon: "https://ssl.gstatic.com/docs/doclist/images/infinite_arrow_favicon_5.ico",
  time: 80
}, {
  name: "beta.designqube.com",
  status: "neutral",
  icon: "http://beta.designqube.com/dq_favicon.png",
  time: 80
}, {
  name: "mail.google.com",
  status: "productive",
  icon: "https://ssl.gstatic.com/ui/v1/icons/mail/images/favicon5.ico",
  time: 10
}, {
  name: "facebook.com",
  status: "unproductive",
  icon: "https://facebook.com/favicon.ico",
  time: 30
}, {
  name: "twitter.com",
  status: "unproductive",
  icon: "https://twitter.com/favicon.ico",
  time: 15
}, {
  name: "figma.com",
  status: "productive",
  icon: "https://static.figma.com/app/icon/1/favicon.ico",
  time: 200
}, {
  name: "pixlr.com",
  status: "neutral",
  icon: "https://pixlr.com/images/pixlr-favicon3-grey-16x16.ico",
  time: 100
}, {
  name: "app.slack.com",
  status: "neutral",
  icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAzFBMVEVKFEyScpNLFU1cK16Mao1hMmOEX4WObZBWJFiQb5FZKFtNGE97VH1QHFJOGVBsQW5jNWV2TXdsQG1aKVxdLV9WI1dwRXGObI9pPGpTIFVPG1FfL2FSH1RVIld8VX1YJlpOGlBbK12RcZJMFk5iNGSBW4JmOGhgMGF3TniLaIx9Vn5lN2eFYYaNa45eLmB5UXtkN2ZUIVaGYodkNmVtQm9YJ1pRHVOHZImCXIN1THZgMWKDXoR9V392TniMaY1nOmmKZ4tpPWtXJVlvRHFqMc1IAAABCklEQVR4Xr3RxZLEIBSG0f9C3NPuPu7u/v7vNEE6dFdRM7s+i0sFvg0EO9X0/CQFeqfeCWwyh4gmCKgSwGJOlRCuWG5gMSKBrcTch03jvwD9Z9eFNcj4gcRj1EE2H5n7OaS93+lA7uXQPKo96kDt9aH4JnDUNS+xEEsLSmKCC0zFMoWY3RmUdBKSFCYDoHPmNCCCaw6DSTC2v8bnw+E9llHrCkBUHkvJbbz1hC4Tl+khWtDaHrQjGXAxH1CSEWwGzUJMH09ktKHkRPTCdBCEdfCKteItj6EDjDuHUvnBsKkO7EywIvr8+juofMNCnnTVUsCird6Gq99o80PkRFh6VcZgFafyYDDDbv0CWLgS6JWTyyIAAAAASUVORK5CYII=",
  time: 100
}, {
  name: "github.com",
  status: "neutral",
  icon: "https://github.com/fluidicon.png",
  time: 100
}, {
  name: "stackoverflow.com",
  status: "neutral",
  icon: "http://cdn.sstatic.net/Sites/stackoverflow/Img/favicon.ico",
  time: 100
}
/**
 * this app has invalid favicon url
 * chart loading time increases, when the broken url is given
 * */
// {
//   name: "theincredibleindiaandtheworldofthe21stcentury.in",
//   status: "neutral",
//   icon: "http://theincredibleindiaandtheworldofthe21stcentury.in/favicon.ico",
//   time: 20,
// },
];
var colors = ["#5c85d6", "#f06442", "#ffad33", "#15c41f", "#cc00cc", "#3e7cbb", "#d14848", "#85dd00", "#e56f96", "#00c0f9"];
var formatDates = function formatDates(globalStartDate, globalEndDate) {
  var startDate = Number(moment(globalStartDate).format("x"));
  var endDate = globalEndDate ? Number(moment(globalEndDate).format("x")) : startDate;
  return {
    startDate: startDate,
    endDate: endDate
  };
};
var PersonalDashboard = /*#__PURE__*/React.memo(function PersonalDashboard(props) {
  var globalStartDate = props.startDate,
    globalEndDate = props.endDate;
  var _React$useState = React.useState(formatDates(globalStartDate, globalEndDate)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dates = _React$useState2[0],
    setDates = _React$useState2[1];
  useEffect(function () {
    setDates(formatDates(globalStartDate, globalEndDate));
  }, [globalStartDate, globalEndDate]);
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var _useQuery = useQuery(USER_TOP_APPS_USED_QUERY, {
      variables: {
        startDate: startDate,
        endDate: endDate
      }
    }),
    appsData = _useQuery.data,
    appsLoading = _useQuery.loading,
    appsError = _useQuery.error;
  var _useQuery2 = useQuery(PERSONAL_DASHBOARD_METRICS_QUERY, {
      variables: {
        startDate: startDate,
        endDate: endDate
      }
    }),
    workData = _useQuery2.data,
    workLoading = _useQuery2.loading,
    workError = _useQuery2.error;
  var rows = React.useMemo(function () {
    var work = workData === null || workData === void 0 ? void 0 : workData.personalDashboardMetrics;
    if (!work) return [];
    return [["Productive", work.productiveMins], ["Unproductive", work.unproductiveMins], ["Neutral", work.neutralMins]];
  }, [workData === null || workData === void 0 ? void 0 : workData.personalDashboardMetrics]);
  if (appsLoading || workLoading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (appsError || workError) {
    return /*#__PURE__*/React.createElement("div", null, "Error");
  }
  if (!appsData || !workData) {
    return null;
  }
  var apps = appsData.userTopAppsUsed;
  var work = workData.personalDashboardMetrics;
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-dashboard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pd-stats"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pd-greetings"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "pd-greetings-name"
  }, "Hi Venkatesh,"), /*#__PURE__*/React.createElement(ProgressChart, {
    rows: rows,
    data: ["Productive hours"]
  })), /*#__PURE__*/React.createElement(StatsGrid, {
    work: work
  })), /*#__PURE__*/React.createElement("div", {
    className: "pd-app-usage"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pd-top-apps-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pd-tal-header"
  }, /*#__PURE__*/React.createElement("h5", null, "Top Apps and Websites"), /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, "View Total Usage")), /*#__PURE__*/React.createElement(TopApps, {
    apps: apps
  })), /*#__PURE__*/React.createElement("div", {
    className: "pd-top-apps-chart"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pd-tal-header"
  }, /*#__PURE__*/React.createElement("h5", null, "Top Apps and Websites Chart")), /*#__PURE__*/React.createElement(AppUsageChart, {
    apps: apps.slice(0, 10)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "pd-work-chart"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pd-tal-header"
  }, /*#__PURE__*/React.createElement("h5", null, "Activities")), /*#__PURE__*/React.createElement(ActivityChart, {
    data: work === null || work === void 0 ? void 0 : work.workTimeSummary,
    from: startDate,
    to: endDate
  })));
});
var PersonalDashboardWrapper = function PersonalDashboardWrapper() {
  var _React$useContext = React.useContext(FilterContext),
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate;
  return /*#__PURE__*/React.createElement(PersonalDashboard, {
    startDate: startDate,
    endDate: endDate
  });
};
export default PersonalDashboardWrapper;
var AppUsageChart = /*#__PURE__*/React.memo(function AppUsageChart(props) {
  var apps = props.apps;
  var rows = React.useMemo(function () {
    return apps.map(function (app) {
      return [app.title, {
        v: app.timeSpentInMins,
        f: "".concat(app.timeSpentInMins, " minutes")
      }];
    });
  }, []);
  if (rows.length < 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pd-tal-content disabled"
    }, "No data");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pd-tal-content"
  }, /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "450px",
    chartType: "PieChart",
    loader: /*#__PURE__*/React.createElement("div", {
      className: "pd-chart-loader"
    }, /*#__PURE__*/React.createElement(Spinner, {
      animation: "border",
      role: "status",
      variant: "primary"
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Loading..."))),
    columns: [{
      label: "App/Website",
      type: "string"
    }, {
      label: "Time spent (in mins)",
      type: "number"
    }],
    rows: rows,
    options: {
      // Just add this option
      pieHole: 0.4,
      colors: colors
    }
    // rootProps={{ "data-testid": "4" }}
  }));
});
var ActivityChart = /*#__PURE__*/React.memo(function ActivityChart(props) {
  var data = props.data,
    from = props.from,
    to = props.to;
  var rows = React.useMemo(function () {
    var r = [];
    var daysDifference = moment(to).diff(from, "days");
    var _loop = function _loop() {
      var day = moment(from).add(index, "day");
      var fromRow = data.find(function (d) {
        return moment(d.workedDay).isSame(day, "day");
      });
      var productive = {
        v: (fromRow === null || fromRow === void 0 ? void 0 : fromRow.productiveMins) || 0,
        f: "".concat((fromRow === null || fromRow === void 0 ? void 0 : fromRow.productiveMins) || 0, " minutes")
      };
      var unproductive = {
        v: (fromRow === null || fromRow === void 0 ? void 0 : fromRow.unproductiveMins) || 0,
        f: "".concat((fromRow === null || fromRow === void 0 ? void 0 : fromRow.unproductiveMins) || 0, " minutes")
      };
      var neutral = {
        v: (fromRow === null || fromRow === void 0 ? void 0 : fromRow.neutralMins) || 0,
        f: "".concat((fromRow === null || fromRow === void 0 ? void 0 : fromRow.neutralMins) || 0, " minutes")
      };
      r.push([day.format("MMM D"), productive, unproductive, neutral]);
    };
    for (var index = 0; index < daysDifference; index++) {
      _loop();
    }
    return r;
  }, []);
  if (!data) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pd-tal-content disabled"
    }, "No data");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pd-tal-content"
  }, /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "400px",
    chartType: "ColumnChart",
    loader: /*#__PURE__*/React.createElement("div", {
      className: "pd-chart-loader"
    }, /*#__PURE__*/React.createElement(Spinner, {
      animation: "border",
      role: "status",
      variant: "primary"
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Loading..."))),
    columns: [{
      type: "string",
      label: "date"
    }, {
      type: "number",
      label: "Productive"
    }, {
      type: "number",
      label: "Unproductive"
    }, {
      type: "number",
      label: "Neutral"
    }],
    rows: rows,
    options: {
      titleTextStyle: {
        color: "#404040",
        fontSize: 20,
        bold: true
      },
      chartArea: {
        width: "80%"
      },
      bar: {
        groupWidth: "35%"
      },
      isStacked: true,
      vAxis: {
        minValue: 0,
        format: "# mins",
        minorGridlines: {
          color: "transparent"
        },
        gridlines: {
          color: "#ededed"
        }
      },
      hAxis: {
        format: "MMM dd",
        gridlines: {
          color: "transparent"
        }
      },
      series: {
        0: {
          color: "#2ECC71"
        },
        1: {
          color: "#E74C3C"
        },
        2: {
          color: "#BDC3C7"
        }
      },
      legend: {
        position: "bottom",
        alignment: "middle"
      }
    }
  }));
});
export var ProgressChart = /*#__PURE__*/React.memo(function ProgressChart(_ref) {
  var rows = _ref.rows,
    setFocusedRow = _ref.setFocusedRow,
    data = _ref.data;
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoaded = _React$useState4[0],
    setLoaded = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    focusedRowSelf = _React$useState6[0],
    setFocusedRowSelf = _React$useState6[1];
  var selectedRowSelf = focusedRowSelf || rows[0];
  var isEmpty = React.useMemo(function () {
    return rows.every(function (r) {
      return r[1] < 1;
    });
  }, [rows]);
  if (isEmpty) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pd-progress-chart-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pd-progress-chart-content disabled"
    }, /*#__PURE__*/React.createElement("p", null, "No data")));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pd-progress-chart-wrapper"
  }, /*#__PURE__*/React.createElement(Chart, {
    width: "180px",
    height: "180px",
    chartType: "PieChart",
    loader: /*#__PURE__*/React.createElement("div", {
      className: "pd-chart-loader"
    }, /*#__PURE__*/React.createElement(Spinner, {
      animation: "border",
      role: "status",
      variant: "primary"
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Loading..."))),
    columns: [{
      label: "Work Type",
      type: "string"
    }, {
      label: "Time spent (in mins)",
      type: "number"
    }],
    rows: rows,
    options: {
      // Just add this option
      pieHole: 0.8,
      chartArea: {
        width: 165,
        height: 165
      },
      legend: {
        position: "none"
      },
      backgroundColor: "transparent",
      pieSliceText: "none",
      colors: [appStatusColors.productive, appStatusColors.unproductive, appStatusColors.neutral]
    },
    chartEvents: [{
      eventName: "ready",
      callback: function callback(_ref2) {
        var chartWrapper = _ref2.chartWrapper,
          google = _ref2.google;
        setLoaded(true);
        var chart = chartWrapper.getChart();
        google.visualization.events.addListener(chart, "onmouseover", function (e) {
          var row = e.row;
          if (setFocusedRow) {
            setFocusedRow(rows[row]);
          } else {
            setFocusedRowSelf(rows[row]);
          }
        });
        google.visualization.events.addListener(chart, "onmouseout", function () {
          if (setFocusedRow) {
            setFocusedRow(null);
          } else {
            setFocusedRowSelf(null);
          }
        });
      }
    }]
    // rootProps={{ "data-testid": "4" }}
  }), isLoaded ? /*#__PURE__*/React.createElement("div", {
    className: "pd-progress-chart-content"
  }, data.map(function (d, i) {
    var Tag = i === 1 ? "h4" : "p";
    return /*#__PURE__*/React.createElement(Tag, {
      key: "progress-chart-".concat(d)
    }, i === 0 && !setFocusedRow ? "".concat(selectedRowSelf[0], " hours") : d);
  }), data.length < 2 ? /*#__PURE__*/React.createElement("h4", null, "".concat(convertToHoursAndMinutes(selectedRowSelf[1], "short"))) : null) : null);
});
var Stats = /*#__PURE__*/React.memo(function Stats(_ref3) {
  var label = _ref3.label,
    value = _ref3.value,
    status = _ref3.status;
  var good = status === "good";
  var bad = status === "bad";
  var displayValue = React.useMemo(function () {
    return formatMetrics(value, label.includes("Productivity"));
  }, [value, label]);
  return /*#__PURE__*/React.createElement("div", {
    key: "stats-grid-".concat(label),
    className: classNames("pd-sg-item", {
      good: good
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, label, good || bad ? /*#__PURE__*/React.createElement("img", {
    src: good ? statsUp : statsDown
  }) : null), /*#__PURE__*/React.createElement("h4", {
    className: classNames("content", {
      disabled: displayValue === "Not available"
    })
  }, displayValue));
});
var StatsGrid = /*#__PURE__*/React.memo(function StatsGrid(props) {
  var work = props.work;
  var stats = React.useMemo(function () {
    var workMins = Math.round(work.neutralMins + work.productiveMins + work.unproductiveMins);
    var productivityPercentage = Math.round(work.productiveMins / workMins * 100);
    return {
      productiveMins: {
        status: getProgressDirection(work.productiveMins, work.avgProductiveMins),
        value: work.productiveMins
      },
      productivityPercentage: {
        status: getProgressDirection(productivityPercentage, work.avgProductivityPercentage),
        value: productivityPercentage
      },
      workMins: {
        status: getProgressDirection(workMins, work.avgWorkMins),
        value: workMins
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "pd-stats-grid"
  }, /*#__PURE__*/React.createElement(Stats, _extends({
    label: "Productive Hours"
  }, stats.productiveMins)), /*#__PURE__*/React.createElement(Stats, {
    label: "Avg. Productive Hours",
    value: work.avgProductiveMins
  }), /*#__PURE__*/React.createElement(Stats, _extends({
    label: "Productivity"
  }, stats.productivityPercentage)), /*#__PURE__*/React.createElement(Stats, {
    label: "Most Productive Day",
    value: work.mostProductiveDay
  }), /*#__PURE__*/React.createElement(Stats, _extends({
    label: "Screen Time"
  }, stats.workMins)), /*#__PURE__*/React.createElement(Stats, {
    label: "Avg. Screen Time",
    value: work.avgWorkMins
  }));
});
function TopApps(props) {
  var apps = props.apps;
  if (apps.length < 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pd-tal-content disabled"
    }, "No data");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pd-tal-content"
  }, apps.slice(0, 10).map(function (app) {
    return /*#__PURE__*/React.createElement("div", {
      key: "top-apps-list-".concat(app.title),
      className: classNames("pd-tal-app", app.productivityStatus)
    }, /*#__PURE__*/React.createElement("img", {
      src: app.icon || "",
      alt: app.title,
      className: "pd-tal-app-icon",
      onError: function onError(ev) {
        ev.target.style.opacity = "0";
        ev.target.alt = "";
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "pd-tal-app-name"
    }, app.title), /*#__PURE__*/React.createElement("span", {
      className: "pd-tal-app-status"
    }, app.productivityStatus));
  }));
}
export function formatMetrics(value, isPercentage) {
  if (!value) return "Not available";
  if (isPercentage) return "".concat(value, "%");
  if (typeof value === "number") {
    return convertToHoursAndMinutes(value, "medium");
  }
  return value;
}
export function getProgressDirection(v1, v2) {
  if (!v1 || v1 === v2) return null;
  if (v1 > v2) return "good";
  return "bad";
}